import ResetPasswordPage from "../reset-password/reset.password.page";
import React from "react";
import { useHistory } from "react-router-dom";
import applicationComander from "../../../store/commanders/application.comander";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLongArrowAltLeft,
  faCircleUser,
} from "@fortawesome/free-solid-svg-icons";
import { useForm } from "@mantine/form";
import { Box, Button, Group, Space, Text, TextInput } from "@mantine/core";
import { validateEmail } from "../../../helpers/form.validators";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { Icon } from "@fortawesome/fontawesome-svg-core";
import { useTranslation } from "react-i18next";

const LegacyForgotPasswordPage = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const existsEmailValue =
    props &&
    props.location &&
    props.location.state &&
    props.location.state.email
      ? props.location.state.email
      : null;

  const form = useForm({
    initialValues: {
      email: existsEmailValue,
    },

    validate: {
      email: validateEmail,
    },
  });

  const onSubmit = (data) => {
    applicationComander.cmd_forgot_password(data.email);
  };
  return (
    <div>
      <div className="auth-container-box">
        <Box className="auth-single-form">
          <FontAwesomeIcon
            icon={faCircleUser as Icon}
            size={"5x"}
            className="auth-icon"
          />
          <Text className="auth-title" style={{fontSize: '2rem'}}>{t("auth.forgot.title")}</Text>
          <Text className="auth-description">
            {t("auth.forgot.description")}
          </Text>
          <form
            onSubmit={form.onSubmit((values) => onSubmit(values))}
            className="u-w-100"
          >
            <TextInput
              required
              type="email"
              autoComplete="email"
              label={t("auth.email")}
              placeholder={t("auth.emailPlaceholder")}
              className="u-w-100"
              {...form.getInputProps("email")}
            />
            <Space h="md" />
            <Group mt="lg" mb="sm">
              <Button size="lg" type="submit" className="u-w-100 auth-submit-button">
                {t("auth.forgot.submit")}
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="u-w-100 mobile-auth-button"
                onClick={() => history.push(URL_PATHS.LOGIN)}
              >
                {t("auth.backToLogin")}
              </Button>
            </Group>
            <Space h={"sm"}></Space>
            <Text
              component="button"
              type="button"
              size="sm"
              align="left"
              className="auth-link"
              onClick={() => history.push(URL_PATHS.LOGIN)}
            >
              <FontAwesomeIcon icon={faLongArrowAltLeft as Icon} />
              <span className="u-ml-sm">{t("auth.backToLogin")}</span>
            </Text>
          </form>
        </Box>
      </div>
    </div>
  );
};

export default function ForgotPasswordPage(props) {
  return process.env.REACT_APP_AUTH_MODE !== "cognito"
    ? <ResetPasswordPage {...props} /> : <LegacyForgotPasswordPage {...props} />;
}
